import { NgModule } from 'ng-metadata/core';
import { SearchVisaRequirementComponent } from './visa-requirement.component';

@NgModule({
  declarations: [
    SearchVisaRequirementComponent,
  ],
})
export class SearchVisaRequirementModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/visa-requirement/visa-requirement.module.ts